import { AuthUser__UserFragment as User } from '@/graphql/api/generated'

export interface IChatService {
  init?(): void
  setUser?(user: User): void
  reset(): void
  toggle?(state?: 'open' | 'close'): void
}

export enum ChatServiceType {
  Chatwoot = 'chatwoot',
  Crisp = 'crisp',
}
